import React, { useEffect, useState } from "react";
import useHttp from "../../Hooks/use-http";
import LiveMap from "./LiveTracking";
import DefaultImage from ".././../Assets/adminAlternative.png";
import formatDateTime from "../CommonComponent/timeFormatT";

let rider_data = [];
const DriverData = (props) => {
  const [driverData, setDriverData] = useState([]);

  if (sessionStorage.getItem("interval")) {
    clearInterval(sessionStorage.getItem("interval"));
    sessionStorage.removeItem("interval");
  }
  // Removed riderApiCall state and riderList function - corporateriders API should only be called during booking

  const driverList = (data) => {
    let collectedDriverData = [];

    for (let i = 0; i < data?.DriverList?.length; i++) {
      const updatedAtUTC = data.DriverList[i].updatedAt;
      const updatedAtIST = updatedAtUTC
        ? new Date(updatedAtUTC).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            hour12: true,
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          })
        : null;

      collectedDriverData.push({
        // driverName: data.DriverList[i].DriverName,
        driverName: data.DriverList[i].fName + " " + data.DriverList[i].lName,

        // driverEmail: data.DriverList[i].DriverEmailID,
        driverEmail: data.DriverList[i].emailID,

        // carNumber: data.DriverList[i].CarNumber,
        carNumber: data.DriverList[i].vehicleNumber,

        driverImage: data.DriverList[i].DriverImage ?? DefaultImage,
        mobileNumber: data.DriverList[i].mobileNumber,

        // vehicleType: data?.DriverList[i]?.VehicleTypes?.toLowerCase().includes(
        //   "basic"
        // )
        //   ? "BASIC"
        //   : data?.DriverList[i]?.VehicleTypes?.toLowerCase().includes("+")
        //   ? "COMFORT+"
        //   : data?.DriverList[i]?.VehicleTypes?.toLowerCase().includes("shuttle")
        //   ? "SHUTTLE"
        //   : "COMFORT",
        driverType: data?.DriverList[i].driverType?.toUpperCase(),
        // carModel: data.DriverList[i].CarModel,
        carModel: data.DriverList[i].vehicleModal,
        carType: data.DriverList[i].vehicleType,

        carColor: data.DriverList[i].shiftCarColor,

        shiftCarModel: data.DriverList[i].shiftVehicleModal,
        shiftCarType: data.DriverList[i].shiftVehicleType,

        shiftCarColor: data.DriverList[i].shiftVehicleColor,
        shiftCarNumber: data.DriverList[i].shiftVehicleNumber,

        isOnline: data.DriverList[i].isOnline,
        // isOnTrip:
        //   data.DriverList[i].IsOnline == "1"
        //     ? data.DriverList[i].LiveStatus
        //     : "0",
        isOnTrip: data?.DriverList[i]?.tripID != null ? "1" : "0",
        isShiftStarted: data.DriverList[i].IsShiftStarted,
        activeShiftCororateName:
          data.DriverList[i]?.shiftStartedInCorporateName,
        activeShiftCorporateId: data.DriverList[i]?.shiftStartedInCorporateID,
        tripType: data.DriverList[i]?.TripType || null,
        corporateName: data.DriverList[i]?.shiftStartedInCorporateName,
        tripId: data.DriverList[i].tripID,
        lastLL: data?.DriverList[i]?.LastLL,
        isApproved: data?.DriverList[i]?.isApproved,
        lastUpdatedAt: formatDateTime(updatedAtIST),
        shiftStartedInCorporateName: data.DriverList[i]?.shiftStartedInCorporateName,
        shiftStartedInCorporateID: data.DriverList[i]?.shiftStartedInCorporateID,
      });
    }
    setDriverData(collectedDriverData);
  };

  const { isLoading, sendRequest } = useHttp();

  useEffect(() => {
    sendRequest(
      {
        // url: "/api/v1/DriverList/DriverListV2",
        url: "/corporatedrivers",

        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          // roleID: localStorage.getItem("roleId"),
          data: {
            filter: {
              corporateID:
                localStorage.getItem("roleId") == "1"
                  ? ""
                  : localStorage.getItem("corpId"),
            },
          },

          // isRider: "0",
          // isDriver: "1",
        },
      },
      driverList
    );
  }, [sendRequest]);
  
  // Removed corporateriders API call - it should only be called during booking, not in dashboard

  return (
    <LiveMap
      driverData={driverData}
      isLoading={isLoading}
      riderData={rider_data}
      toggle={props.toggle}
    />
  );
};

export default DriverData;
